export const IS_AUTHENTICATED = 'isAuthenticated';

export const IS_NOT_AUTHENTICATED = 'isNotAuthenticated';



// WEBPACK FOOTER //
// ./src/router/guardsTypes.js